import { Component, Output, EventEmitter } from '@angular/core';
import { AIChatbotService } from '../../services/ai-chatbot/ai-chatbot.service';

export interface AIChatbotSuggestionItem {
  emoji: string;
  text: string;
}

@Component({
  selector: 'ai-chatbot-suggestions',
  templateUrl: './ai-chatbot-suggestions.component.html',
  styleUrl: './ai-chatbot-suggestions.component.scss',
  standalone: false,
})
export class AiChatbotSuggestionsComponent {
  @Output() suggestionSelected = new EventEmitter<string>();

  constructor(public aiChatbotService: AIChatbotService) {}

  suggestions: AIChatbotSuggestionItem[] = [
    {
      emoji: '📅',
      text: 'Promote an upcoming event using key dates and details with a modern style.',
    },
    {
      emoji: '🎂',
      text: 'Celebrate a birthday using a person’s name and celebratory message with cheerful style.',
    },
    {
      emoji: '👤',
      text: 'Recognize an employee using their name and accomplishment with a sophisticated style.',
    },
  ];
}
